<template>
  <rest-list-column
    prop="labels"
    :title="$t('CampaignsList_Field_Labels')"
    :min-width="200"
    :sortable="false"
  >
    <template v-slot:default="scope">
      <el-popover
        popper-class="rest-list-column-labels-tooltip"
        placement="top"
        width="300"
        trigger="hover"
        :content="formatLabels(scope.row.labels)"
      >
        <div slot="reference">
          <el-tag
            v-for="(label, index) in scope.row.labels"
            :key="index"
            size="small"
            effect="plain"
            class="label-tag"
            :data-qa="formatDataQa(scope.row.title, label.name)"
            :disable-transitions="true"
          >
            {{ label.name }}
          </el-tag>
        </div>
      </el-popover>
    </template>
  </rest-list-column>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'

export default {
  name: 'RestListColumnLabels',

  components: { RestListColumn },

  methods: {
    formatLabels(labels) {
      return labels
        .map(label => {
          return label.name
        })
        .join(', ')
    },
    formatDataQa(campaignTitle, labelName) {
      return (
        'campaign-' +
        campaignTitle
          .toLowerCase()
          .replace(/ /g, '_')
          .replace(/\W/g, '') +
        '-label-' +
        labelName.toLowerCase()
      )
    }
  }
}
</script>
<style scoped lang="scss">
.label-tag {
  padding-top: 2px;
  color: #7e8596;
  font-family: Open Sans;
  font-weight: 600;
  background-color: #ebeef5;
  border: none;
  margin-right: 10px;
}
>>> .el-icon-price-tag {
  transform: rotate(315deg);
}
</style>
<style>
.rest-list-column-labels-tooltip {
  text-align: center;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnLabel.vue